import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30 * 1000, // 30 seconds
    },
    mutations: {
      retry: 0,
    },
  },
})

// Query keys for type safety and consistency
export const queryKeys = {
  // Auth
  auth: {
    me: ['auth', 'me'] as const,
  },

  // Leads
  leads: {
    all: ['leads'] as const,
    list: (filters?: object) => ['leads', 'list', filters] as const,
    detail: (id: string) => ['leads', 'detail', id] as const,
    comments: (leadId: string) => ['leads', 'comments', leadId] as const,
    specifications: (leadId: string) => ['leads', 'specifications', leadId] as const,
  },

  // Clients
  clients: {
    all: ['clients'] as const,
    list: (filters?: object) => ['clients', 'list', filters] as const,
    detail: (id: string) => ['clients', 'detail', id] as const,
  },

  // Projects
  projects: {
    all: ['projects'] as const,
    kanban: ['projects', 'kanban'] as const,
    detail: (id: string) => ['projects', 'detail', id] as const,
  },

  // Stages
  stages: {
    all: ['stages'] as const,
  },

  // Payments
  payments: {
    all: ['payments'] as const,
    byProject: (projectId: string) => ['payments', 'project', projectId] as const,
    detail: (id: string) => ['payments', 'detail', id] as const,
  },

  // Documents
  documents: {
    all: ['documents'] as const,
    byProject: (projectId: string) => ['documents', 'project', projectId] as const,
    detail: (id: string) => ['documents', 'detail', id] as const,
  },

  // Dashboard
  dashboard: {
    stats: ['dashboard', 'stats'] as const,
  },

  // Pipeline
  pipeline: {
    all: ['pipeline'] as const,
  },

  // Activities
  activities: {
    all: ['activities'] as const,
    list: (filters?: object) => ['activities', 'list', filters] as const,
  },

  // Users
  users: {
    all: ['users'] as const,
  },

  // Meetings
  meetings: {
    all: ['meetings'] as const,
    list: (filters?: object) => ['meetings', 'list', filters] as const,
    detail: (id: string) => ['meetings', 'detail', id] as const,
  },

  // Integrations
  integrations: {
    fireflies: ['integrations', 'fireflies'] as const,
  },

  // Settings
  settings: {
    ai: ['settings', 'ai'] as const,
  },
}
